import Accordion from '../components/Accordion';
import AjaxPanels from '../components/AjaxPanels';
import InclusionDetailsLoad from '../components/InclusionDetailsLoad';
import { initSpecificPhotoSlideShows } from '../components/SpecificPhotoSlideshow';
import StickyNav from '../components/StickyNav';
import { initMap } from '../components/CommunityMap';
import GalleryPlanPhotoSlideshow from '../components/GalleryPlanPhotoSlideshow';
import FloorPlanOptionViewer from '../components/FloorPlanOptionViewer';
import QuickViewModal from '../components/QuickViewModal';
import Modal from '../components/Modal';
import FloorplanZoom from '../components/FloorplanZoom';
import Panels from '../components/Panels';
import GalleryVideoPlayers from '../components/GalleryVideoPlayers';


document.addEventListener('DOMContentLoaded', () => {
    //sticky nav init
    const stickyNav = StickyNav();
    stickyNav.init();

    const inclusionsLoad = InclusionDetailsLoad(true, () => {
        stickyNav.refresh();
    });

    AjaxPanels(
        'js-hfs-inclusion-panels',
        'js-hfs-inclusion-panel-content',
        () => {
            inclusionsLoad.reinitialize();
            Panels('js-bath-panels', () => { stickyNav.refresh() });            
            stickyNav.refresh();
        },
    );

    GalleryPlanPhotoSlideshow();
    GalleryVideoPlayers.initPlayers();        
    Panels('js-plan-gallery-panels', () => GalleryVideoPlayers.stopPlaying());
    initSpecificPhotoSlideShows();
    Accordion('js-fp-details-accordion');
    
    
    FloorPlanOptionViewer();

    FloorplanZoom();

    const quickviewModal = QuickViewModal('js-quickview-modal');

    //download modal    
    const downloadModal = Modal('js-download-modal');
    const downloadModalBtns = document.querySelectorAll('.js-btn-downloads');
    downloadModalBtns.forEach(downloadModalBtn => {
        downloadModalBtn.addEventListener('click', event => {
            event.preventDefault();
            downloadModal.open();
        });
    });

    const notifyModal = Modal('js-notify-modal');

    if (notifyModal) {
        const notifyModalBtns = document.querySelectorAll('.js-btn-notify');
        notifyModalBtns.forEach(notifyModalBtn => {
            notifyModalBtn.addEventListener('click', event => {
                event.preventDefault();
                notifyModal.open();
            });
        });
    }
});

window.addEventListener('load', () => {
    //initialize map
    initMap().catch(error => {
        console.error('Failed to initialize map:', error);
    });
});
